import styled from "styled-components";

export default {
    "Wrapper": styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;

        & > button {
            width: 18px;
            height: 18px;
            text-align: left;

            img {
                height: 18px;
            }
        }

        & > h2 {
            ${({ theme }) => theme.font["xlarge-semibold"]};
        }

        & > p {
            width: 8px;
        }
    `,
}